module.exports = __webpack_public_path__ + "static/media/447612645_304724046045945_3378697768364830862_n.0b31d375.jpg";